import {Component} from '@angular/core';
import {AppBreadcrumbComponent} from '../app.breadcrumb.component';

// Breadcrumb de Avalon (p-breadcrumb) con los mismos avisos y accesos del de Teki.
@Component({
    selector: 'app-cbet-breadcrumb',
    template: `
        <div class="cbet-breadcrumb">
            <p-breadcrumb class="cbet-breadcrumb__ruta" [model]="items" [home]="home"></p-breadcrumb>
            <div class="cbet-breadcrumb__acciones">
                <a *ngIf="(companySelected$ | async)?.verNotificacionYape === true" routerLink="/pagos-yape"
                   class="flex align-items-center" pTooltip="Ver pagos Yape" tooltipPosition="bottom" aria-label="Ver pagos Yape">
                    <img src="assets/static/yape.png" alt="" width="28"/>
                    <app-notification-count-badge [notificationTypes]="yapeNotificationTypes"></app-notification-count-badge>
                </a>
                <app-network-indicator></app-network-indicator>
            </div>
        </div>
        <app-activation-notice *ngIf="!appMain?.esProduccion"></app-activation-notice>
    `,
    styles: [`
        .cbet-breadcrumb {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 0.5rem;
        }

        /* la ruta cede espacio para que la fila nunca sea más ancha que la pantalla */
        .cbet-breadcrumb__ruta {
            flex: 1 1 auto;
            min-width: 0;
        }

        .cbet-breadcrumb__acciones {
            display: flex;
            flex: 0 0 auto;
            align-items: center;
            gap: 0.5rem;
        }

        /* en móvil la conexión se muestra solo con el ícono (el texto queda en el tooltip)
           y la ruta va en una línea, recortando el último tramo si no entra */
        @media (max-width: 640px) {
            .cbet-breadcrumb__acciones ::ng-deep .network-indicator .status-text {
                display: none;
            }

            .cbet-breadcrumb__ruta ::ng-deep .p-breadcrumb {
                padding: 0.75rem;
            }

            .cbet-breadcrumb__ruta ::ng-deep .p-breadcrumb ul {
                flex-wrap: nowrap;
            }

            .cbet-breadcrumb__ruta ::ng-deep .p-breadcrumb li {
                flex-shrink: 0;
            }

            .cbet-breadcrumb__ruta ::ng-deep .p-breadcrumb li:last-child {
                flex-shrink: 1;
                min-width: 0;
            }

            .cbet-breadcrumb__ruta ::ng-deep .p-breadcrumb li:last-child .p-menuitem-link {
                display: block;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
    `],
    standalone: false
})
export class CbetBreadcrumbComponent extends AppBreadcrumbComponent {
    home = {icon: 'pi pi-home', routerLink: '/'};
}
